import I18n from 'I18n';
import { ContentAssignmentsSearch, useContentAssignmentsSearchContext } from './ContentAssignmentsSearch';
import { UnassignContentButton } from './UnassignContentButton';
import { CardMenuOptions } from '../../cardMenu/components/CardMenu';
import { SideNavItem } from 'foundations-components/transitional/components/SideNav';
import { Button } from 'foundations-components/transitional/components/Button';
import formatName from 'I18n/utils/formatName';
import AvatarViewer from '../../avatar/components/AvatarViewer';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { LeftIcon } from 'foundations-assets/icons/components/LeftIcon';
import { View } from 'foundations-components/transitional/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const UnassignContentHeader = ({
  labelMessage
}) => {
  const {
    selectedPortalId,
    unselectPortal
  } = useContentAssignmentsSearchContext();
  return selectedPortalId ? /*#__PURE__*/_jsxs(Button, {
    onClick: unselectPortal,
    use: "link",
    children: [/*#__PURE__*/_jsx(LeftIcon, {}), /*#__PURE__*/_jsx(FormattedMessage, {
      message: "academyCommon.playlistAssignments.backLink"
    })]
  }) : /*#__PURE__*/_jsx(FormattedMessage, {
    message: labelMessage
  });
};
export const UnassignContentLoadMore = () => {
  const {
    selectedPortalId
  } = useContentAssignmentsSearchContext();
  return /*#__PURE__*/_jsx(FormattedMessage, {
    message: selectedPortalId ? 'academyCommon.cardMenu.loadMoreAssignments' : 'academyCommon.cardMenu.loadMorePortals'
  });
};
const UnassignContentListPortalList = ({
  portals,
  renderList = content => /*#__PURE__*/_jsx(CardMenuOptions, {
    "aria-label": I18n.text('academyCommon.playlistAssignments.portalsHeader'),
    children: content
  }),
  renderRow = (content, key) => /*#__PURE__*/_jsx(SideNavItem, {
    title: content
  }, key),
  onPortalClick
}) => {
  return renderList(portals && portals.map(({
    portal: {
      id,
      companyName,
      domain
    },
    contentId
  }) => {
    return renderRow( /*#__PURE__*/_jsx(Button, {
      block: true,
      onClick: () => {
        if (onPortalClick) onPortalClick(id);
      },
      use: "unstyled",
      children: /*#__PURE__*/_jsx(View, {
        inlineSize: "100%",
        textAlign: "start",
        children: companyName || domain
      })
    }), `portal_${contentId}_${id}`);
  }));
};
const UnassignContentListAssignmentList = ({
  assignments,
  renderList = content => /*#__PURE__*/_jsx(CardMenuOptions, {
    "aria-label": I18n.text('academyCommon.playlistAssignments.assigneesHeader'),
    children: content
  }),
  renderRow = (content, key) => /*#__PURE__*/_jsx(SideNavItem, {
    title: content
  }, key),
  onAssignmentClick,
  onUnassigned
}) => {
  const handleOnUnassigned = (portalId, assignmentId) => {
    if (onUnassigned) onUnassigned(portalId, assignmentId);
  };
  return renderList(assignments && assignments.map(({
    contentId,
    portalId,
    id,
    assignee: {
      avatarHash,
      firstName,
      lastName
    }
  }) => {
    const displayName = formatName({
      firstName,
      lastName
    });
    return renderRow( /*#__PURE__*/_jsx(UnassignContentButton, {
      assignments: [id],
      onDeleted: () => handleOnUnassigned(portalId, id),
      render: ({
        handleOnClick
      }) => /*#__PURE__*/_jsx(Button, {
        block: true,
        onClick: e => {
          handleOnClick(e);
          if (onAssignmentClick) onAssignmentClick(portalId, id);
        },
        use: "unstyled",
        children: /*#__PURE__*/_jsx(TFlex, {
          children: /*#__PURE__*/_jsx(AvatarViewer, {
            avatarHash: avatarHash,
            displayName: displayName,
            renderName: true,
            size: "xs",
            type: "contact"
          })
        })
      })
    }), `portal_${contentId}_${portalId}_${id}`);
  }));
};
export const UnassignContentList = ({
  contentId,
  contentType,
  renderList,
  renderRow,
  loadMoreButton,
  onPortalClick,
  onAssignmentClick,
  onUnassigned
}) => {
  const {
    selectPortal
  } = useContentAssignmentsSearchContext();
  const handleOnPortalClick = portalId => {
    selectPortal(portalId);
    if (onPortalClick) onPortalClick(portalId);
  };
  return /*#__PURE__*/_jsx(ContentAssignmentsSearch, {
    contentId: contentId,
    contentType: contentType,
    loadMoreButton: loadMoreButton,
    renderAssignments: assignments => assignments && /*#__PURE__*/_jsx(UnassignContentListAssignmentList, {
      assignments: assignments,
      onAssignmentClick: onAssignmentClick,
      onUnassigned: onUnassigned,
      renderList: renderList,
      renderRow: renderRow
    }),
    renderPortals: portals => portals && /*#__PURE__*/_jsx(UnassignContentListPortalList, {
      onPortalClick: handleOnPortalClick,
      portals: portals,
      renderList: renderList,
      renderRow: renderRow
    })
  });
};
export default UnassignContentList;